import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthModuleService } from '../services/auth-module.service';

/**
 * Bare `/login` carries no method in the path. Resolve the module from
 * `?module=` (defaulting to `tx`) and redirect to the route matching that
 * module's seeded method: `tx` → `/login/email`, `business` → `/login/sms`.
 * The `?module=` query param is preserved through the redirect.
 */
export const loginModuleRedirectGuard: CanActivateFn = (route) => {
  const authModule = inject(AuthModuleService);
  const router = inject(Router);

  const module = authModule.resolveModule(route.queryParamMap.get('module'));
  const path = authModule.defaultMethodFor(module) === 'email' ? '/login/email' : '/login/sms';

  return router.createUrlTree([path], { queryParams: route.queryParams });
};
